import type { AddressDetails } from './types';

function parseStreetAddress(addressComponents: google.maps.GeocoderAddressComponent[]): string {
	const streetNumberComponent = addressComponents.find((component) => component.types.includes('street_number'));
	const routeComponent = addressComponents.find((component) => component.types.includes('route'));

	return `${streetNumberComponent?.long_name || ''} ${routeComponent?.long_name || ''}`;
}

export function parsePlaceDetails(placeDetails: google.maps.places.PlaceResult): AddressDetails {
	const addressComponents = placeDetails.address_components || [];
	const cityComponent = addressComponents.find((component) => component.types.includes('locality'));
	const stateComponent = addressComponents.find((component) => component.types.includes('administrative_area_level_1'));
	const countryComponent = addressComponents.find((component) => component.types.includes('country'));
	const postalCodeComponent = addressComponents.find((component) => component.types.includes('postal_code'));

	return {
		address: parseStreetAddress(addressComponents),
		city: cityComponent?.long_name || '',
		stateCode: stateComponent?.short_name || '',
		countryCode: countryComponent?.short_name || '',
		postalCode: postalCodeComponent?.long_name || '',
	};
}
